import { BreadCrumbs } from '@app/components/BreadCrumbs';
import { Layout } from '@app/components/Layout';
import { ListView } from './ListView';

export function BusinessLibrary() {
  return (
    <Layout>
      <BreadCrumbs
        links={[
          {
            label: 'Student Portal',
            link: '/',
          },
          {
            label: 'Business Library',
            link: '/business-library',
          },
        ]}
      />
      <ListView />
    </Layout>
  );
}
